module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0074.jpg?v=1920f6ad";